import { Component, OnDestroy, OnInit } from '@angular/core';
import { LogoComponent } from '@layout/components/logo/logo.component';
import { ProfileComponent } from '@layout/components/profile/profile.component';
import { CommonComponent } from '@components/common.component';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { NotificationsComponent } from '@notifications/notifications.component';
import { NotificationsDashboardComponent } from '@notifications/components/notifications-dashboard/notifications-dashboard.component';
import { CustomEventComponent } from '@calendar/components/custom-event/custom-event.component';
import { ConversationComponent } from '@messages/components/conversation/conversation.component';
import { AddResidentComponent } from '@directory/components/add-resident/add-resident.component';
import { authenticationActions } from '@redux/authentication.redux';
import { get } from 'lodash-es';

@Component({
  selector: 'app-top-bar',
  standalone: true,
  imports: [
    LogoComponent,
    NotificationsComponent,
    ProfileComponent,
    AsyncPipe,
    NgIf,
    NgForOf,
    NotificationsComponent,
    NotificationsDashboardComponent,
  ],
  templateUrl: './top-bar.component.html',
  styleUrl: './top-bar.component.scss',
})
export class TopBarComponent extends CommonComponent implements OnInit, OnDestroy {
  isCondensed = false;

  ngOnInit(): void {
    this.checkWindowSize();
    window.addEventListener('resize', this.onResize.bind(this));
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    window.removeEventListener('resize', this.onResize.bind(this));
  }

  onResize() {
    this.checkWindowSize();
  }

  checkWindowSize() {
    if (window.innerWidth <= 1200) {
      if (window.innerWidth > 993) {
        this.isCondensed = true;
        document.body.classList.add('vertical-collpsed');
      } else {
        document.body.classList.remove('vertical-collpsed', 'sidebar-enable');
      }
    } else {
      this.isCondensed = false;
      document.body.classList.remove('vertical-collpsed');
      document.body.classList.add('sidebar-enable');
    }
  }

  onToggleMobileMenu() {
    this.isCondensed = !this.isCondensed;
    document.body.classList.toggle('sidebar-enable');
    document.body.classList.toggle('vertical-collpsed');

    if (window.screen.width <= 993) {
      document.body.classList.remove('vertical-collpsed');
    }
  }

  onCustomEvent() {
    this.modal.show(CustomEventComponent, {
      backdrop: 'static',
      class: 'modal-dialog-centered',
    });
  }

  onConversation() {
    this.modal.show(ConversationComponent, {
      backdrop: 'static',
      class: 'modal-dialog-centered',
    });
  }

  onAddResident() {
    this.modal.show(AddResidentComponent, {
      backdrop: 'static',
      class: 'modal-dialog-centered',
    });
  }

  onChange($event: Event) {
    const id = get($event.target, 'value');
    if (id) this.store.dispatch(authenticationActions.selectResident({ id }));
  }
}
